import React, { useEffect, useRef, useState } from 'react'
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import {
  Card, CardBody, CardHeader, Container,
  Nav, NavItem, Row, Col,
  Input, Label, Modal,
  ModalHeader, ModalBody
} from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { createFont, getFontCss, getFonts, handleFonts, updateFont } from '../../../../slices/fonts/thunk';
import { createSelector } from 'reselect';
import DropFile from '../../../../Components/Common/DropFıle';
import FontPicker from './FontPicker';
import JSZip from 'jszip';
import { fontTypes, fontWeight, possibleFontWidthKeys } from '../../../../common/font';
import { filterFonts, setFontCss, setFontNotFound, setFonts, setFontUploaded, setIsFontLoading, setSelectedFonts } from '../../../../slices/fonts/reducer';
import Preloader from '../../../../Components/Common/Preloader';
import opentype from 'opentype.js';
import { setBreadcrumb } from '../../../../slices/auth/menu/reducer';
import { toggleFontModal } from '../../../../slices/modals/reducer';
import SimpleBar from 'simplebar-react';
import { getFontStyleFromTempDiv } from '../../../../slices/fonts/helper';
import { toast } from 'react-toastify';
import { getFontList } from '../../../../slices/campaigns/thunk';

function FontModal() {
  const dispatch = useDispatch();

  const selectFonts = createSelector(state => state, state => ({
    fontModal: state.Modal.fontModal,
    fonts: state.Font.fonts,
    fontNotFound: state.Font.fontNotFound,
    selectedFonts: state.Font.selectedFonts,
    fontCss: state.Font.fontCss,
    fontUploaded: state.Font.fontUploaded,
    isFontLoading: state.Font.isFontLoading,
    filteredFontList: state.Campaign.filteredFontList,
  }));
  const {
    fontModal,
    fonts,
    fontNotFound,
    selectedFonts,
    fontCss,
    fontUploaded,
    isFontLoading,
    filteredFontList
  } = useSelector(selectFonts);
  const [brandFonts, setBrandFonts] = useState([]);
  const [brandFontSelected, setBrandFontSelected] = useState(false);
  const [simplebarHeight, setSimplebarHeight] = useState(220);
  const fontRef = useRef();
  const uploadRef = useRef();

  useEffect(() => {
    dispatch(setFonts([]));
    dispatch(setFontCss(''));
  }, []);

  useEffect(() => {
    if (filteredFontList) {
      setBrandFonts(filteredFontList.filter(item => item.isGoogleFonts === false));
    }
  }, [filteredFontList]);

  useEffect(() => {
    setTimeout(() => {
      checkSimplebar();
    }, 1)
  }, [fonts, brandFonts]);

  function toggleModal() {
    dispatch(toggleFontModal());
  }

  async function handleUpload(files) {
    const filesArr = [];
    let style = ``;
    dispatch(setFonts([]));
    try {
      for (let i = 0; i < files.length; i++) {
        if (files[i].type === 'application/zip') {
          const zip = new JSZip();
          const zipFiles = await zip.loadAsync(files[i]);
          const zipEntries = Object.entries(zipFiles.files);
          for (let k = 0; k < zipEntries.length; k++) {
            await handleFontFile(zipEntries[k][1], zipEntries[k][0], filesArr, style);
          }
        } else if (files[i].type.includes('font')) {
          await handleFontFile(files[i], files[i].name, filesArr, style);
        } else {
          return;
        }
      }
      dispatch(setFonts(filesArr));
      dispatch(setFontCss(style));
      dispatch(setFontUploaded(true));
      dispatch(setFontNotFound(false));
    } catch (error) {
      // console.log('upload error', error);
    }
  }

  async function handleFontFile(fontFile, fontName, filesArr, style) {
    let type = fontName.split('.').pop();
    if (fontTypes.includes(type)) {
      let weight = 400;
      // let fontStyle = 'normal';
      let fontStyle;

      for (const key in fontWeight) {
        if (fontName.toLowerCase().includes(key)) {
          weight = fontWeight[key];
          break;
        }
      }

      let fileBlob, fileBuffer, fileEntry;
      if (fontFile instanceof File) {
        fileEntry = fontFile;
        fileBuffer = await toArrayBuffer(fontFile);
      } else if (fontFile instanceof Object) {
        fileBlob = await fontFile.async("blob");
        fileBuffer = await fontFile.async("arraybuffer");
        fileEntry = new File([fileBlob], fontName, { type: "font/" + type });
      }


      try {
        const font = await opentype.parse(fileBuffer);
        fontStyle = setFontFamily(font, fontStyle);
        weight = (font?.tables?.os2?.usWeightClass ? font?.tables?.os2?.usWeightClass : weight);
        const family = (font.names.preferredFamily?.en ? font.names.preferredFamily?.en : font.names.fontFamily.en)
        const fontWidth = setFontWidth(font);
        const base64 = await toBase64(fileEntry);

        filesArr.push({
          family: family + fontWidth,
          style: fontStyle,
          weight: weight,
          format: type,
          src: base64,
          file: fileEntry
        });

        style += `@font-face { \n
          font-family: '${family + fontWidth}'; \n
          src: url('${base64}') \n format('truetype'); \n
          font-weight: ${weight}; \n 
          font-style: ${fontStyle}; \n
        }\n`;

        const styleEl = document.createElement('style');
        styleEl.textContent = style;
        document.head.appendChild(styleEl);

        // const fontFace = new FontFace(family, `url(${base64})`);
        // fontFace.load().then(() => {
        //   document.fonts.add(fontFace);
        // });

      } catch (err) {
        // console.log('e', err);
      }
    }
  }

  function setFontFamily(font, fontStyle) {
    if (!fontStyle && (font.names?.fontSubfamily?.en.toLowerCase().includes('italic') || font.names?.fontSubfamily?.en.toLowerCase().includes('oblique'))) {
      fontStyle = 'italic';
    }
    if (!fontStyle && (font.names?.postScriptName?.en.toLowerCase().includes('italic') || font.names?.postScriptName?.en.toLowerCase().includes('oblique'))) {
      fontStyle = 'italic';
    }
    if (!fontStyle && (font.names?.preferredFamily?.en.toLowerCase().includes('italic') || font.names?.preferredFamily?.en.toLowerCase().includes('oblique'))) {
      fontStyle = 'italic';
    }
    if (!fontStyle && (font.names?.preferredSubfamily?.en.toLowerCase().includes('italic') || font.names?.preferredSubfamily?.en.toLowerCase().includes('oblique'))) {
      fontStyle = 'italic';
    }
    if (!fontStyle) {
      fontStyle = 'normal'
    }
    return fontStyle;
  }

  function setFontWidth(font) {
    let fontWidth = '';
    let i = 0;
    do {
      const key = possibleFontWidthKeys[i];
      let name = '';
      if (font.names[key]) {
        if (typeof font.names[key] === 'string') {
          name = font.names[key]
        } else if (font.names[key]?.en) {
          name = font.names[key]?.en;
        }

        if (name.toLowerCase().includes('condensed') || name.toLowerCase().includes('cond')) {
          fontWidth = ' Condensed';
        } else if (name.toLowerCase().includes('expanded')) {
          fontWidth = ' Expanded';
        }
      }
      i++;
    } while (i < possibleFontWidthKeys.length);
    return fontWidth;
  }

  function toBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  function toArrayBuffer(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = () => {
        reject(reader.error);
      };

      reader.readAsArrayBuffer(file);
    });
  }

  function handleSelect(font) {
    const isFontAdded = selectedFonts.find(item => item.idx === font.idx);
    if (isFontAdded) {
      dispatch(setSelectedFonts(selectedFonts.filter(item => item.idx !== font.idx)));
    } else {
      dispatch(setSelectedFonts([...selectedFonts, font]));
    }
  }

  function handleDelete(e, idx) {
    // const filteredFonts = fonts.filter((item, idx) => font.idx !== idx);    
    // dispatch(setFonts(filteredFonts));
    const backupFonts = [...fonts];
    dispatch(setFonts([]));
    setTimeout(() => {
      dispatch(filterFonts({ fonts: backupFonts, index: idx }));
    }, 1);
    // dispatch(setSelectedFonts(selectedFonts.filter(item => item.idx !== font.idx)));
  }

  async function uploadFonts() {
    if (selectedFonts.length > 0) {
      dispatch(setIsFontLoading(true));
      await dispatch(handleFonts());
      await dispatch(getFontList());
      dispatch(setSelectedFonts([]));
      dispatch(setFonts([]));
      dispatch(setIsFontLoading(false));
    } else {
      toast.error('Please select font', { autoClose: 3000 });
    }
  }

  let typingTimer;
  let doneTypingInterval = 250;
  async function handleSearch(e) {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(async () => {
      if (e.target.value === "" || e.target.value === " ") {
        setBrandFonts(filteredFontList.filter(item => !item.isGoogleFonts));
      } else {
        const filteredFonts = filteredFontList.filter(item => item.family === e.target.value && !item.isGoogleFonts);
        if (filteredFonts) {
          dispatch(setFontNotFound(false));
          setBrandFonts(filteredFonts);
        } else {
          dispatch(setFontNotFound(true));
        }
        // dispatch(getFonts(e.target.value));
      }
      dispatch(setFontUploaded(false));
    }, doneTypingInterval);
  }

  async function handleBrandFontSelect(item) {
    setBrandFontSelected(true);
    dispatch(setFontUploaded(false));
    const fontCss = await dispatch(getFontCss(item.family));
    const styleEl = document.createElement('style');
    styleEl.textContent = fontCss.payload;
    document.head.appendChild(styleEl);
    dispatch(getFonts(item.family));
  }

  function handleDeselect() {
    setBrandFontSelected(false);
    dispatch(setFonts([]));
    dispatch(setFontUploaded(false));
    checkSimplebar();
  }

  function checkSimplebar() {
    if (fontRef.current && fontRef.current.offsetHeight > 220) {
      setSimplebarHeight(fontRef.current.offsetHeight - 50);
    } else {
      setSimplebarHeight(220);
    }
  }

  return (
    <Modal isOpen={fontModal} toggle={toggleModal} size='xl' centered>
      <ModalHeader className='py-3' toggle={toggleModal}>Fonts</ModalHeader>
      <ModalBody>
        {isFontLoading ?
          <Row className='mt-2'>
            <Preloader isComponentLoader={true} />
          </Row>
          :
          <Row>
            <Col>
              <Row>
                {fontNotFound ?
                  <div className='h-100 d-flex align-items-center mb-3'>
                    <p className='text-danger m-0'>This font is not installed on the system. Please upload your own font from the upload section.</p>
                  </div>
                  : null}
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Row>
                    <div className="form-icon">
                      <Input type="text" className="form-control form-control-icon" placeholder="Search Font" onKeyUp={handleSearch} />
                      <i className="ri-search-line search-icon text-muted" style={{ left: '28px' }}></i>
                    </div>
                  </Row>
                  <Row>
                    <div className='font-container'>
                      <div className='w-100 d-flex align-items-center justify-content-between my-2'>
                        <b>Brand Fonts</b>
                        {brandFontSelected ?
                          <button className='btn btn-success ms-auto me-0 mb-1' onClick={handleDeselect}>Upload Font</button>
                          : null}
                      </div>
                      {brandFonts ?
                        <SimpleBar style={{ width: "100%", maxHeight: `${simplebarHeight}px`, overflowX: "hidden" }}>
                          {brandFonts.length > 0 ? (
                            <div className='w-100 d-flex flex-column mb-2'>
                              {brandFonts.map((item, idx) => {
                                if (item?.isMain) {
                                  return (
                                    <button className='white-space-prewrap p-2 dropdown-item font-item' key={idx} onClick={() => { handleBrandFontSelect(item) }}>
                                      {item?.family}
                                    </button>
                                  )
                                }
                              })}
                            </div>
                          ) : null}
                        </SimpleBar>
                        : null}
                    </div>
                  </Row>
                </Col>
                <Col xl={8} lg={8} md={6} sm={12}>
                  {fonts.length > 0 ?
                    <Row className='mt-2'>
                      <div className='w-100 d-flex flex-column align-items-center justify-content-center p-0 font-picker-container' ref={fontRef}>
                        {(fonts || []).map((font, idx) => {
                          return (
                            <FontPicker font={font} key={idx} idx={idx} handleSelect={(font, idx) => handleSelect({ ...font, idx: idx })} fontUploaded={fontUploaded} handleDelete={(e, item) => handleDelete(e, item)} />
                          )
                        })}
                        {fontUploaded ?
                          <button className='btn btn-success mt-5' onClick={uploadFonts}>
                            + Save Selected Fonts
                          </button>
                          : null}
                      </div>
                    </Row>
                    :
                    <Row className='mt-2'>
                      <Label>Upload Fonts</Label>
                      <Container fluid>
                        <div>
                          <DropFile handleUpload={async (files) => await handleUpload(files)} size='lg' message='Drop files here or click to upload.' />
                        </div>
                      </Container>
                    </Row>
                  }
                </Col>
              </Row>
            </Col>
          </Row>
        }

      </ModalBody>
    </Modal>
  )
}

export default FontModal;